<form [formGroup]="form" (ngSubmit)="start()">
  <nb-card class="dialog">
    <nb-card-header>
      <h4>{{ "pages.creator.moodleDialog.title" | translate }}</h4>
    </nb-card-header>
    <nb-card-body>
      <p class="intro">{{ "pages.creator.moodleDialog.intro" | translate }}</p>

      <div class="field">
        <label class="label" for="moodle-title">{{ "pages.creator.moodleDialog.name" | translate }} *</label>
        <input
          nbInput
          fullWidth
          id="moodle-title"
          type="text"
          formControlName="title"
          maxlength="200"
          [placeholder]="'pages.creator.moodleDialog.namePlaceholder' | translate"
        />
      </div>

      <div class="field">
        <label class="label" for="moodle-description">{{ "pages.creator.moodleDialog.description" | translate }} *</label>
        <textarea
          nbInput
          fullWidth
          id="moodle-description"
          rows="3"
          formControlName="description"
          [placeholder]="'pages.creator.moodleDialog.descriptionPlaceholder' | translate"
        ></textarea>
        <p class="hint">{{ "pages.creator.moodleDialog.descriptionHint" | translate }}</p>
      </div>

      <div class="field">
        <label class="label" for="moodle-goals">{{ "pages.creator.moodleDialog.learningGoals" | translate }}</label>
        <textarea
          nbInput
          fullWidth
          id="moodle-goals"
          rows="2"
          formControlName="learningGoals"
          [placeholder]="'pages.creator.moodleDialog.learningGoalsPlaceholder' | translate"
        ></textarea>
      </div>

      <div class="field field--narrow">
        <label class="label" for="moodle-difficulty">{{ "pages.creator.moodleDialog.difficulty" | translate }}</label>
        <nb-select id="moodle-difficulty" formControlName="difficultyLevel" fullWidth>
          <nb-option value="EASY">{{ "pages.creator.moodleDialog.difficulties.EASY" | translate }}</nb-option>
          <nb-option value="MEDIUM">{{ "pages.creator.moodleDialog.difficulties.MEDIUM" | translate }}</nb-option>
          <nb-option value="HARD">{{ "pages.creator.moodleDialog.difficulties.HARD" | translate }}</nb-option>
        </nb-select>
      </div>
    </nb-card-body>
    <nb-card-footer>
      <button type="button" nbButton status="danger" outline (click)="cancel()">
        {{ "buttons.cancel" | translate }}
      </button>
      <button type="submit" nbButton status="primary" alAnchor="creator.moodle-start">
        {{ "pages.creator.moodleDialog.start" | translate }}
      </button>
    </nb-card-footer>
  </nb-card>
</form>
